import React , { useRef, useEffect, useState } from "react";
import "../assets/style/components/Footer.scss";
import { Link } from "react-router-dom";
import * as Icon from 'react-bootstrap-icons';
import { trackEvent } from "../components/CookiePopup"; 

const Footer = () => {
    
    const dividerRef = useRef(null);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const observer = new window.IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setExpanded(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.5 }
        );
        if (dividerRef.current) {
            observer.observe(dividerRef.current);
        }
        return () => observer.disconnect();
    }, []);


    return (
        <footer className="footer">
            <div className="container py-3">
                <div className="row h-100 m-5">
                    <div className="col-lg-3 col-sm-6">
                        <img src="pictures/logo.svg" className="footer-logo" alt="logo"/>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <h2 className="section-title">Suivez-nous</h2>
                        <div className="footer-row">
                            <a href="https://www.facebook.com/profile.php?id=61578900155498" className="social-btn rounded-circle" onClick={() => trackEvent("social_click", { platform: "facebook", location: "footer" })}>
                                <Icon.Facebook size={30}/>
                            </a>
                            <a href="https://www.instagram.com/havre_de_priya/" className="social-btn rounded-circle" onClick={() => trackEvent("social_click", { platform: "instagram", location: "footer" })}>
                                <Icon.Instagram size={30}/>
                            </a>
                        </div>  
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <h2 className="section-title">Navigation</h2>
                        <div className="footer-column">
                            <div className="link"><Link to="/">Accueil</Link></div>
                            <div className="link"><Link to="/infrastructures">Infrastructures</Link></div>
                            <div className="link"><Link to="/pensions">Prestations</Link></div>
                            <div className="link"><Link to="/actualites">Actualités</Link></div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <h2 className="section-title">Nous trouver</h2>
                        <div className="footer-column">
                            <p className="section-text"><Icon.PinMap size={20}/> 8 Rue du Moulin, 90110 Felon</p>
                            {/*<p className="section-text"><Icon.Phone size={20}/> +33 1 23 45 67 89</p>*/}
                            <button className="action-btn">
                                <a href="https://maps.app.goo.gl/zWWXKL4WX84eYnfm6">Google Maps</a>
                            </button>
                        </div>
                    </div>
                </div>
                <div ref={dividerRef} className={`animated-divider${expanded ? " expanded" : ""}`}></div>
                <div className="centered-row-container gap-3">
                    <p className="text-center primary-text">&copy; 2025 Havre de Priya</p>
                    <p className="link"><Link to="/mentions">Mentions légales</Link></p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;